import type { SubscriptionUpdateValues } from '@entities/subscription'

import { runApiWrite } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'

import { useSubscriptionsStore } from '../model/store'

interface SubscriptionUpdateOptions {
  subscriptionId: number
  payload: SubscriptionUpdateValues
}

/** `PATCH /admin-api/subscriptions/{subscription}` — comment, auto-renew and deal owner; only sent keys change. */
export const useSubscriptionUpdate = async (options: SubscriptionUpdateOptions): Promise<boolean> => {
  const store = useSubscriptionsStore()

  return runApiWrite(useAdminRoutes('admin.subscription.update', { subscription_id: options.subscriptionId }), {
    method: 'patch',
    payload: { ...options.payload },
    setLoading: store.trackProcessing,
  })
}
